exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ch2-product-category[data-v-2177696a]{margin-bottom:70px}.ch2-product-category-heading h2[data-v-2177696a]{font-size:24px;font-weight:700;margin-right:16px;line-height:40px;margin-bottom:29px}.ch2-product-category-heading span[data-v-2177696a]{font-size:13px}ul[data-v-2177696a]{list-style:none;padding:0}", ""]);

// exports
